<template>
    <div class="patient_selection_form_inner batch_patients_data_use_wrp">
        <div class="create_model_first_step center_container_sm" v-if="useModelFirstStep">
            <form @submit.prevent="stepFirstUseFormMethod">
                <div class="form-group">
                    <label>Patient Name</label>
                    <input type="text" class="form-control" v-validate="'required'" v-model="patient_name"
                        name="patient_name" v-bind:class="{ 'is-invalid': errors.has('patient_name') }"
                        data-vv-as="name" autocomplete="off">
                    <small class="invalid-feedback" v-if="errors.has('patient_name')">{{ errors.first('patient_name')
                    }}</small>
                </div>
                <button class="btn btn-primary" type="submit" :disabled="submitted">Next</button>
            </form>
        </div>
        <div class="create_model_second_step center_container_sm" v-if="useModelSecondStep">
            <form @submit.prevent="stepSecondUseFormMethod">
                <div class="form-group text-center">
                    <p class="mb-0 blurb_f_s_file">To make predictions on multiple patient data sets, simply fill up our
                        Sample File with your data. The file already has predefined columns for your convenience, so
                        there's no need to change its name when you upload it. Please contact our Admin team in case of
                        assistance or to ensure accurate predictions based on your data.</p>
                </div>
                <div class="form-group pt-2 text-center">
                    <template v-if="selectedModelInfo && selectedModelInfo.blurb">
                        <label class="sample_file_link" @click="openPrdctnFileblurbMethod">
                            <i class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                            Download Sample File
                        </label>
                    </template>
                    <template v-else>
                        <label class="sample_file_link" @click="sampleFileDonwloadMethod"
                            :disabled="downloadFileIsSubmitted">
                            <i class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                            Download Sample File
                        </label>
                    </template>
                </div>
                <div class="form-group text-center pt-3">
                    <label>OR</label>
                </div>
                <div class="form-group pt-3">
                    <div class="batch_file_upload_btn" :class="uploadAttachmentName ? 'uploaded_file_box' : ''">
                        <label for="upload_attachment">
                            <input type="file" id="upload_attachment" name="file" ref="file"
                                @change="handleAttachmentUpload" v-validate="'required'"
                                v-bind:class="{ 'is-invalid': errors.has('file') }"
                                accept=".xls,.xlt,.xlm,.xlsx,.xltx,.xltm, .xlsb, .xla,.xlam, .xll, .xlw, .xlsm"
                                data-vv-as="upload file" hidden />
                            <div class="batch_file_upload_span">
                                <span class="uploaded_file_name" v-if="uploadAttachmentName">{{
                                    this.uploadAttachmentName }}</span>
                                <template v-else>
                                    <span class="file_upload_icon"><i class="fa fa-cloud-upload"
                                            aria-hidden="true"></i></span>
                                    <span class="browse_file_label">
                                        <div class="btn btn-danger">Upload File</div>
                                    </span>
                                    <span class="supported_files_span">Supported file types : <strong>xls, xlt, xlm,
                                            xlsx</strong></span>
                                </template>
                            </div>
                        </label>
                        <span class="cleared_uploaded_data_cross" v-if="uploadAttachmentName">
                            <i class="fa fa-times-circle-o" aria-hidden="true" @click="clearedUploadedFileMethod"></i>
                        </span>
                        <small class="invalid-feedback d-block" v-if="errors.has('file')">{{ errors.first('file')
                        }}</small>
                    </div>
                </div>
                <button class="btn btn-primary mt-4" type="submit" :disabled="submitted">Predict</button>
                <span class="model_trained_loader mt-4" v-if="modelTrainedLoader"><img
                        src="@/assets/images/progressbar.gif" class="img-fluid"></span>
            </form>
        </div>
        <!--  Predicted File For Popup Code Here -->
        <div class="batch_predicted_file_modal" v-if="predictedBatchFilePopupState">
            <div class="batch_predicted_file_modal_body">
                <div class="batch_predicted_file_header">
                    <span class="batch_predicted_popup_close">
                        <i class="fa fa-times-circle" aria-hidden="true"
                            @click="predictedBatchFilePopupCloseMethod"></i>
                    </span>
                    <h2>The prediction is added to the file. Would you like to download?</h2>
                    <div class="text-center mt-5">
                        <button class="btn btn-success" v-if="modelOutputData"
                            @click="downloadPredictedFileMethod(modelOutputData.input_data)">Yes</button>
                        <button class="btn btn-success" v-else>Yes</button>
                        <button class="btn btn-danger ml-4" @click="predictedBatchFilePopupCloseMethod">No</button>
                    </div>
                </div>
            </div>
        </div>
        <!--  Predicted File For Popup Code Here -->
        <!--  Predicted File Error For Popup Code Start Here -->
        <div class="predication_error_popup" v-if="predicationErrorPopupState">
            <div class="predication_error_modal">
                <div class="predication_error_modal_center">
                    <div class="predication_error_modal_body">
                        <p>{{ predicationErrorText }}</p>
                        <div class="text-center">
                            <button class="btn btn-success" @click="closePredicationErrorPopupMethod"
                                style="min-width:70px;">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  Predicted File Error For Popup Code End Here -->
        <!--  Blurb For The Batch Predication Here -->
        <div class="predication_error_popup" v-if="prdctnFileDownloadFblurb">
            <div class="predication_error_modal">
                <div class="predication_error_modal_center">
                    <div class="predication_error_modal_body">
                        <div v-html="selectedModelInfo.blurb" class="blurb_batch_file"></div>
                        <div class="text-center">
                            <button class="btn btn-success" style="min-width:70px;" @click="sampleFileDonwloadMethod"
                                :disabled="downloadFileIsSubmitted">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  Blurb For The Batch Predication Here -->
    </div>
</template>

<script>
/*eslint-disable */

import axios from 'axios';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let sampleFileForModel = root.sampleFileForModelApiUrl.link;
var $ = window.jQuery = require('jquery');
export default {
  name: 'batch-patients-data-use',
  components: {},
  props: ['selectedModelInfo'],
  data() {
    return {
      useModelFirstStep: false,
      useModelSecondStep: true,
      submitted: false,
      patient_name:'',
      file:null,
      uploadAttachmentName:'',
      modelTrainedLoader:false,
      modelOutputData:null,
      predictedBatchFilePopupState:false,
      downloadFileIsSubmitted:false,
      predicationErrorPopupState:false,
      predicationErrorText:'',
      prdctnFileDownloadFblurb:false
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    openPrdctnFileblurbMethod(){
      this.prdctnFileDownloadFblurb = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    closedPrdctnFileblurbMethod(){
      this.prdctnFileDownloadFblurb = false;
      document.body.classList.remove('body_right_scroll_remove');
    },
    sampleFileDonwloadMethod(){
      this.downloadFileIsSubmitted = true;
      axios.get(sampleFileForModel + '?model_id=' + this.selectedModelInfo.id).then((res) => {
        this.downloadSampleFileMethod(res.data.data.input_data);
        this.downloadFileIsSubmitted = false;
        this.closedPrdctnFileblurbMethod();
      })
    },
    predictedBatchFilePopupOpenMethod(){
      this.predictedBatchFilePopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    predictedBatchFilePopupCloseMethod(){
      this.predictedBatchFilePopupState = false;
      document.body.classList.remove('body_right_scroll_remove');
      this.backToFirstStepBatch();
    },
    clearedUploadedFileMethod(){
        this.$refs.file.value = null;
        this.file = null;
        this.uploadAttachmentName = '';
        this.$validator.reset();
    },
    downloadSampleFileMethod(dataurl) {
      fetch(dataurl.file)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = dataurl.file_name;
        link.click();
      }).catch(console.error);
    },
    downloadPredictedFileMethod(dataurl) {
      fetch(dataurl.file)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = dataurl.file_name;
        link.click();
        this.predictedBatchFilePopupCloseMethod();
      }).catch(console.error);
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.file.name;
      }else {
        this.uploadAttachmentName = '';
      }
    },
    stepFirstUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.useModelFirstStep = false;
          setTimeout(()=>{
            this.useModelSecondStep = true;
          },1)
          this.submitted = false;
          return;
        }
      })
    },
    stepSecondUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.modelTrainedLoader = true;
          var formData = new FormData();
          formData.append('file', this.file);
          this.$store.dispatch('modelPredictForBatchDataAction', {data:{id:this.selectedModelInfo.id, data:formData}})
            .then((res) => {  
              this.modelOutputData = res.data.data;
              this.predictedBatchFilePopupOpenMethod();
              toast.success("Request processed successfully");
              this.modelTrainedLoader = false;
              this.submitted =  false;
            }).catch((err) => {
              this.modelTrainedLoader = false;
              this.submitted =  false;
              if(err.data.code == '4001'){
                this.predicationErrorPopupState = true;
                this.predicationErrorText = err.data.data.data;
                document.body.classList.add('body_right_scroll_remove');
              }else{
                toast.error(err.data.user_msg || err.data.msg);
              }
            })
          return;
        }
      })
    },
    backToFirstStepBatch(){
      // this.useModelSecondStep = false
      setTimeout(()=>{
        // this.useModelFirstStep = true
        this.patient_name = '';
        this.clearedUploadedFileMethod();
      }, 1)
    },
    closePredicationErrorPopupMethod(){
      this.patient_name = '';
      this.clearedUploadedFileMethod();
      this.predicationErrorPopupState = false;
      this.predicationErrorText = '';
      document.body.classList.remove('body_right_scroll_remove');
    }
  }
}
</script>

<style lang="scss" scoped>
.batch_patients_data_use_wrp {
    .model_trained_loader {
        margin-top: 15px;
        display: inline-block;
        margin-left: 15px;
        vertical-align: middle;

        .img-fluid {
            width: 28px;
        }
    }

    .models_used_output_wrp h3 {
        color: #ffd400;
        margin-bottom: 15px;
        font-size: 26px;
    }

    .batch_predicted_file_modal {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        align-items: center;

        .batch_predicted_file_modal_body {
            background: #000;
            width: 100%;
            max-width: 620px;
            margin: 0px auto;
            border-radius: 5px;
            padding: 80px 25px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #ffffff;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            position: relative;
        }

        .batch_predicted_file_header h2 {
            font-size: 22px;
            color: #ffffff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-align: center;
            margin: 0;
            line-height: 1.4;

            span {
                display: block;
                font-size: 26px;
                text-transform: uppercase;
                color: #fffcc4;
            }

            a {
                color: #87cefa;
                text-decoration: none;
            }
        }

        .batch_predicted_popup_close {
            position: absolute;
            top: 5px;
            right: 6px;
            line-height: 1;

            .fa {
                font-size: 24px;
                color: red;
                cursor: pointer;
                transform: scale(1);
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -webkit-transition: all ease 0.5s;
                transition: all ease 0.5s;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        .btn {
            min-width: 90px;
            font-size: 18px;
            padding: 8px 0;
            line-height: 1;
            box-shadow: none !important;
            outline: none !important;
        }
    }

    .sample_file_link {
        cursor: pointer;
        margin: 0 !important;
        background: rgba(0, 0, 0, 0.6);
        border: 2px solid #ffc107 !important;
        color: #ffc107 !important;
        text-transform: uppercase;
        font-size: 28px;
        padding: 10px 20px;
        line-height: 1;
        display: inline-block;
        border-radius: 6px;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        letter-spacing: 0.3px;

        .fa {
            font-size: 20px;
        }

        &:hover {
            background: #ffc107 !important;
            color: #000000 !important;
        }
    }

    .batch_file_upload_btn {
        position: relative;

        label {
            position: relative;
            padding: 30px 15px;
            border: 3px dashed rgba(255, 255, 255, 0.3);
            margin: 0;
            line-height: 1;
            border-radius: 10px;
            cursor: pointer;
            margin-bottom: 0px !important;
            word-break: break-all;
            display: block;
            color: rgba(255, 255, 255, 0.3) !important;

            span {
                display: block;
                text-align: center;
                margin-bottom: 20px;

                &:last-child {
                    margin-bottom: 0px !important;
                }

                &.file_upload_icon .fa {
                    font-size: 55px;
                    color: #ffc107;
                }

                &.browse_file_label .btn-danger {
                    background: none;
                    border: 2px solid #ffc107;
                    color: #ffc107;
                    font-size: 18px;
                    line-height: 1;
                    padding: 8px 25px;
                    border-radius: 30px;
                }

                &.supported_files_span {
                    font-size: 16px;

                    strong {
                        font-weight: 600;
                    }
                }
            }
        }

        &.uploaded_file_box {
            label {
                border-color: #ffc107;
            }

            .uploaded_file_name {
                color: #ffc107;
            }
        }

        &:hover {
            label {
                border-color: #ffc107;
            }
        }
    }

    .cleared_uploaded_data_cross {
        position: absolute;
        top: 8px;
        right: 10px;

        .fa {
            color: #f61515;
            font-size: 26px;
            cursor: pointer;

            &:hover {
                color: #87cefa;
            }
        }
    }

    .blurb_f_s_file {
        font-size: 16px;
        text-align: justify;
        color: #ffc107;
    }

    .predication_error_popup {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        align-items: center;

        .predication_error_modal {
            background: #000;
            width: 100%;
            max-width: 540px;
            margin: 0px auto;
            border-radius: 5px;
            padding: 25px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #ffffff;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            position: relative;
            border: 1px solid #ffc800;
        }

        .predication_error_modal_body {
            .blurb_batch_file {
                p {
                    letter-spacing: 1px;
                    color: #ffffff;
                    font-weight: 400;
                    font-size: 18px;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                    line-height: 1.3;
                    text-align: justify;
                }
            }

            p {
                letter-spacing: 1px;
                color: #ffffff;
                font-weight: 400;
                font-size: 18px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                line-height: 1.3;
                text-align: justify;
            }

            .btn-success {
                background: #ffc800;
                border: none;
                color: #000;
                -webkit-box-shadow: none;
                box-shadow: none;
                font-size: 14px;
                font-weight: 600;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                letter-spacing: 1px;

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }
}

.btn-primary {
    padding: 8px 35px;
    height: auto;
    font-size: 16px;
    border-radius: 70px;
    background: rgba(255, 255, 255, 0.12) !important;
    color: #ffffff !important;
    border: none !important;
    text-transform: capitalize;
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;
    box-shadow: none !important;
    letter-spacing: 1px;

    &:hover {
        background: #87cefa !important;
        color: #22292f !important;
    }
}
</style>